import { responseArray, authHeaders } from './apiFetch';

export const getCartLength = async() => {
    try {
        const response = await fetch('/api/user/cart', {
            headers: authHeaders()
        });
        if (response.ok) {
            const results = await response.json();
            return responseArray(results, 'cart').length;
        } else {
            console.error('Failed to fetch updated cart length');
        }
    } catch (error) {
        console.error('Error fetching updated cart length:', error);
    }
    return 0;
}
